(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/widget/assets/javascripts/in-page-admin.js') >= 0) return;  svs.modules.push('/components/content/widget/assets/javascripts/in-page-admin.js'); 'use strict';

svs.content = svs.content || {};
svs.content.widget = svs.content.widget || {};

svs.content.widget.showDetails = e => {
  const $el = $(e.currentTarget);
  const $icon = $el.find('.icon-default');
  $el.find('.js-admin-edit-dropdown').slideToggle();

  if ($icon.hasClass('icon-settings')) {
    $icon.removeClass('icon-settings').addClass('icon-menu-up');
  } else {
    $icon.removeClass('icon-menu-up').addClass('icon-settings');
  }
};


svs.content.widget.addInPageAdminLink = () => {
  if (!svs.content.widget.data) {
    return;
  }

  const adminData = svs.content.widget.data.inPageAdmin;

  if (!adminData.isAdmin) {
    return;
  } 


  const editLinks = $('.js-admin-edit-link');

  if (editLinks && editLinks.length) {
    editLinks.remove();
  }

  const bannerELements = document.querySelectorAll('[data-banner-admin-id]');
  const widgetELements = document.querySelectorAll('[data-widget-admin-id]');

  if (bannerELements) {
    bannerELements.forEach(banner => {
      const bannerId = banner.getAttribute('data-banner-admin-id');
      const hbsCompiled = svs.content.widget.templates.admin_edit;
      const model = {
        url: "/admin/banners/".concat(bannerId)
      };

      const _html = hbsCompiled(model);

      banner.parentNode.insertAdjacentHTML('afterend', _html);
    });
  }

  if (adminData.cmsId && adminData.site && widgetELements) {
    widgetELements.forEach(widget => {
      const widgetId = widget.getAttribute('data-widget-admin-id');
      const hbsCompiled = svs.content.widget.templates.admin_edit_widget;
      const model = {
        url: "/admin/routes/svs-sites-".concat(adminData.site, "/").concat(adminData.cmsId, "/widget/").concat(widgetId),
        placeringUrl: "/admin/routes/svs-sites-".concat(adminData.site, "/").concat(adminData.cmsId, "/widget/").concat(widgetId, "/placement")
      };

      const _html = hbsCompiled(model);

      widget.insertAdjacentHTML('beforeend', _html);
    });
  }
};

svs.content.widget.addInPageAdminLink();
 })(window);